import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1465.103 -4200.39)">
      <path
        d="M175.647,38.14a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1625 4163)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M188.628,45.646a15.056,15.056,0,0,0-5.486-5.486,14.9,14.9,0,0,0-7.494-2.02v15l7.494,12.981a14.957,14.957,0,0,0,5.486-20.475"
        transform="translate(-1625 4163)"
        fill={color}
      />
    </g>
  </svg>
);
